import { render, staticRenderFns } from "./SelectedColor.vue?vue&type=template&id=b4fa7e04&scoped=true&"
import script from "./SelectedColor.vue?vue&type=script&lang=js&"
export * from "./SelectedColor.vue?vue&type=script&lang=js&"
import style0 from "./SelectedColor.vue?vue&type=style&index=0&id=b4fa7e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa7e04",
  null
  
)

export default component.exports